var UNKNOWN_VERSION = 'unknown';
var isValidVersionString = function (version) { return /^\d+\.\d+\.\d+$/.test(version); };
export default (function (url) {
    try {
        var split = url.split('/');
        var possibleVersion = split[split.length - 2];
        return isValidVersionString(possibleVersion)
            ? possibleVersion
            : UNKNOWN_VERSION;
    }
    catch (e) {
        return UNKNOWN_VERSION;
    }
});
//# sourceMappingURL=getAppVersion.js.map